(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svp-banner-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-banner-section]').forEach((section) => {
    const radios = section.querySelectorAll('input[name="id"]');
    const price = section.querySelector('[data-banner-price]');
    const submit = section.querySelector('[data-banner-submit]');
    const upload = section.querySelector('[data-banner-upload]');
    const uploadLabel = section.querySelector('[data-upload-label]');
    const uploadError = section.querySelector('[data-banner-upload-error]');
    const defaultUploadLabel = uploadLabel.textContent;
    const maxUploadBytes = 20000000;
    const galleryButtons = section.querySelectorAll('[data-banner-target]');
    const gallerySlides = section.querySelectorAll('[data-banner-slide]');
    const previousButton = section.querySelector('[data-banner-prev]');
    const nextButton = section.querySelector('[data-banner-next]');
    const galleryStage = section.querySelector('.svp-banner__gallery-stage');
    let activeIndex = 0;
    let touchStartX = 0;

    const showSlide = (index) => {
      activeIndex = (index + gallerySlides.length) % gallerySlides.length;
      gallerySlides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== activeIndex;
      });
      galleryButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === activeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        section.querySelectorAll('.svp-banner__size-card').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.svp-banner__size-card').classList.add('is-selected');
        price.textContent = radio.dataset.price;
        submit.disabled = radio.dataset.available !== 'true';
      });
    });

    upload.addEventListener('change', () => {
      const file = upload.files[0];
      const tooLarge = !!file && file.size > maxUploadBytes;
      if (tooLarge) upload.value = '';
      uploadError.hidden = !tooLarge;
      uploadLabel.textContent = file && !tooLarge ? file.name : defaultUploadLabel;
    });

    galleryButtons.forEach((button, buttonIndex) => {
      button.addEventListener('click', () => {
        showSlide(buttonIndex);
      });
    });

    previousButton.addEventListener('click', () => showSlide(activeIndex - 1));
    nextButton.addEventListener('click', () => showSlide(activeIndex + 1));

    galleryStage.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    galleryStage.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      showSlide(distance > 0 ? activeIndex - 1 : activeIndex + 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svp-card-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const openInbox = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') return false;
    chat.show();
    return true;
  };
  document.addEventListener('click', (event) => {
    const chatButton = event.target.closest('[data-svp-footer-chat]');
    if (!chatButton) return;
    chatButton.setAttribute('aria-busy', 'true');
    const status = document.getElementById(chatButton.getAttribute('aria-describedby'));
    const started = Date.now();
    const tryOpen = () => {
      if (openInbox()) {
        chatButton.removeAttribute('aria-busy');
        if (status) status.hidden = true;
        return;
      }
      if (Date.now() - started < 4000) {
        window.setTimeout(tryOpen, 100);
        return;
      }
      chatButton.removeAttribute('aria-busy');
      if (status) status.hidden = false;
    };
    tryOpen();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svp-five-inch-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.svp5-product').forEach((root) => {
    const updateShapeLabel = () => {
      root.querySelectorAll('.gpo-label .label-content').forEach((label) => {
        if (label.textContent.trim() === 'Would You Like To Specify a Shape?') label.textContent = 'Shape:';
      });
    };
    updateShapeLabel();
    const options = root.querySelector('.svp5-product__app');
    if (options) new MutationObserver(updateShapeLabel).observe(options, { childList: true, subtree: true });
    const mainImage = root.querySelector('.svp5-product__main-image img');
    root.querySelectorAll('[data-svp5-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.image;
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-svp5-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
    const variant = root.querySelector('[data-svp5-variant]');
    const price = root.querySelector('[data-svp5-price]');
    if (variant && price) {
      variant.addEventListener('change', () => {
        const selected = variant.options[variant.selectedIndex];
        if (selected && selected.dataset.price) price.textContent = selected.dataset.price;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svp-master-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.svp5-product').forEach((root) => {
    const form = root.querySelector('form');
    if (form) form.addEventListener('formdata', (event) => {
      const data = event.formData;
      const artwork = data.get('properties[undefined]');
      if (artwork && !data.has('properties[Artwork]')) data.set('properties[Artwork]', artwork);
      data.delete('properties[undefined]');
    });
    const updateShapeLabel = () => {
      root.querySelectorAll('.gpo-label .label-content').forEach((label) => {
        if (label.textContent.trim() === 'Would You Like To Specify a Shape?') label.textContent = 'Shape:';
      });
    };
    updateShapeLabel();
    const options = root.querySelector('.svp5-product__app');
    if (options) new MutationObserver(updateShapeLabel).observe(options, { childList: true, subtree: true });
    const mainImage = root.querySelector('.svp5-product__main-image img');
    root.querySelectorAll('[data-svp5-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.image;
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-svp5-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
    const variant = root.querySelector('[data-svp5-variant]');
    const price = root.querySelector('[data-svp5-price]');
    const optionSelectors = [...root.querySelectorAll('[data-svp-master-option]')];
    const submit = root.querySelector('.svp5-product__submit');
    optionSelectors.forEach((select) => select.addEventListener('change', () => {
      const values = optionSelectors.map((item) => item.value);
      const match = [...variant.options].find((item) => JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(values));
      variant.value = match ? match.value : '';
      submit.disabled = !match || match.disabled;
      submit.textContent = !match ? 'Unavailable' : match.disabled ? 'Sold out' : 'Add to cart';
      if (match) variant.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    if (variant && price) {
      variant.addEventListener('change', () => {
        const selected = variant.options[variant.selectedIndex];
        if (selected && selected.dataset.price) price.textContent = selected.dataset.price;
        if (selected && selected.dataset.image && mainImage) {
          mainImage.src = selected.dataset.image;
          mainImage.removeAttribute('srcset');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
